import _classCallCheck from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { scrapeMotionValuesFromProps as _scrapeMotionValuesFromProps } from './utils/scrape-motion-values.mjs';
import { DOMVisualElement } from '../dom/DOMVisualElement.mjs';
import { buildSVGAttrs } from './utils/build-attrs.mjs';
import { camelToDash } from '../dom/utils/camel-to-dash.mjs';
import { camelCaseAttributes } from './utils/camel-case-attrs.mjs';
import { transformProps } from '../html/utils/transform.mjs';
import { renderSVG } from './utils/render.mjs';
import { getDefaultValueType } from '../dom/value-types/defaults.mjs';
import { createBox } from '../../projection/geometry/models.mjs';
var SVGVisualElement = /*#__PURE__*/function (_DOMVisualElement) {
  _inherits(SVGVisualElement, _DOMVisualElement);
  var _super = _createSuper(SVGVisualElement);
  function SVGVisualElement() {
    _classCallCheck(this, SVGVisualElement);
    return _super.apply(this, arguments);
  }
  _createClass(SVGVisualElement, [{
    key: "getBaseTargetFromProps",
    value: function getBaseTargetFromProps(props, key) {
      return props[key];
    }
  }, {
    key: "readValueFromInstance",
    value: function readValueFromInstance(instance, key) {
      var _a;
      if (transformProps.has(key)) {
        return ((_a = getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
      }
      key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
      return instance.getAttribute(key);
    }
  }, {
    key: "measureInstanceViewportBox",
    value: function measureInstanceViewportBox() {
      return createBox();
    }
  }, {
    key: "scrapeMotionValuesFromProps",
    value: function scrapeMotionValuesFromProps(props) {
      return _scrapeMotionValuesFromProps(props);
    }
  }, {
    key: "build",
    value: function build(renderState, latestValues, options, props) {
      buildSVGAttrs(renderState, latestValues, options, props.transformTemplate);
    }
  }, {
    key: "renderInstance",
    value: function renderInstance(instance, renderState, styleProp, projection) {
      renderSVG(instance, renderState, styleProp, projection);
    }
  }]);
  return SVGVisualElement;
}(DOMVisualElement);
export { SVGVisualElement };